// components/Login/LoginButton.jsx
import React from "react";
import PropTypes from "prop-types";
import { Button } from "@mui/material";
import { useAuth0 } from "@auth0/auth0-react";
import GoogleIcon from "@mui/icons-material/Google";
import WindowIcon from "@mui/icons-material/Window"; // close-enough MS icon
import MailOutlineIcon from "@mui/icons-material/MailOutline";

const AUTH0_AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE;

const providerConfig = {
  google: {
    label: "Continue with Google",
    bg: "#ffffff",
    color: "#111827",
    hoverBg: "#f3f4f6",
    icon: <GoogleIcon fontSize="small" />,
  },
  microsoft: {
    label: "Continue with Microsoft",
    bg: "#2563eb",
    color: "#f9fafb",
    hoverBg: "#1d4ed8",
    icon: <WindowIcon fontSize="small" />,
  },
  email: {
    label: "Continue with your school email",
    bg: "#0f766e",
    color: "#f9fafb",
    hoverBg: "#115e59",
    icon: <MailOutlineIcon fontSize="small" />,
  },
};

const providerToConnection = {
  google: "google-oauth2",
  microsoft: "vibeu-microsoft-login",
  email: "Username-Password-Authentication",
};

const LoginButton = ({ provider }) => {
  const { loginWithRedirect } = useAuth0();

  const config = providerConfig[provider] || providerConfig.google;
  const connection = providerToConnection[provider];

  const handleClick = () => {
    loginWithRedirect({
      authorizationParams: {
        redirect_uri: `${window.location.origin}/post-login`,
        audience: AUTH0_AUDIENCE,
        scope: "openid profile email",
        connection: connection,
      },
    });
  };

  return (
    <Button
      fullWidth
      onClick={handleClick}
      startIcon={config.icon}
      sx={{
        mt: 1,
        borderRadius: 999,
        textTransform: "none",
        fontWeight: 600,
        fontSize: "0.95rem",
        paddingY: 1.1,
        backgroundColor: config.bg,
        color: config.color,
        boxShadow: "0 12px 30px rgba(15,23,42,0.45)",
        "&:hover": {
          backgroundColor: config.hoverBg,
          boxShadow: "0 16px 40px rgba(15,23,42,0.6)",
        },
      }}
    >
      {config.label}
    </Button>
  );
};

LoginButton.propTypes = {
  provider: PropTypes.oneOf(["google", "microsoft", "email"]).isRequired,
};

export default LoginButton;
